import React, { useEffect, useState } from 'react';
import { FaCheckCircle, FaExclamationCircle } from 'react-icons/fa';
import { classCompleted, userHasEnrolled } from '../../../services/currentUser';
import CourseDashboardButton from '../../btns/CourseDashboardButton';
import { fetchCourse } from '../../../services/courses';

const IconStatus = ({ hasCompletedClass, hasEnrolled }) => {
  return (
    <>
      {!hasCompletedClass && (
        <FaExclamationCircle
          className={`fas fa-exclamation-circle ml-2 ${hasEnrolled ? 'text-danger' : 'text-light'}`}
          title="Prerequisite Incomplete"
        />
      )}
      {hasCompletedClass && (
        <FaCheckCircle
          className="text-keppel ml-2"
          title="Prerequisite Complete"
        />
      )}
    </>
  );
};

const PreReqStatus = ({ course, currentUser, className = '', slim }) => {
  const [prerequisite, setPrerequisite] = useState(null);
  const [hasCompletedClass, setHasCompletedClass] = useState(false);
  const [hasEnrolled, setHasEnrolled] = useState(false);
  // Course
  const prerequisiteId = course?.prerequisiteId || null;

  useEffect(() => {
    if (prerequisiteId && course?.id && currentUser?.id) {
      fetchCourse(prerequisiteId).then((rsp) => {
        setPrerequisite(rsp);

        const completed = classCompleted({
          classId: rsp?.id,
          currentUser
        });
        const enrolled = userHasEnrolled({
          classId: rsp?.id,
          currentUser
        });

        setHasCompletedClass(completed);
        setHasEnrolled(enrolled);
      });
    }
  }, [course?.id, currentUser, prerequisiteId]);

  if (!course?.id || !course?.prerequisiteId || !currentUser?.id) {
    return null;
  }

  if (slim) {
    return (
      <div className="text-muted">
        <b>Prereq:</b> {prerequisite?.title}
        <IconStatus
          hasCompletedClass={hasCompletedClass}
          hasEnrolled={hasEnrolled}
        />
      </div>
    );
  }

  return (
    <div className={className}>
      <b>Prerequisite:</b>
      <p className="text-muted mt-1 mb-0 d-flex align-items-center">
        <CourseDashboardButton
          classId={prerequisiteId}
          className="btn btn-link p-0 m-0"
        >
          {prerequisite?.title}
        </CourseDashboardButton>
        <IconStatus
          hasCompletedClass={hasCompletedClass}
          hasEnrolled={hasEnrolled}
        />
      </p>
    </div>
  );
};

export default PreReqStatus;
